export default {
    ID: "3",
    SLUG: "milkbun",
    NAME: " Milkbun",
    PRIMARY: "#4BB9EE",
    SECONDARY: "#38c172",
    API: "https://api.milkbun.io",
    LOGO: "/Assets/milkbun/ena.png",
    APP_ICON: "/Assets/milkbun/milkbun.svg",
    APP_LOGO: "/Assets/milkbun/milkbun.svg",
    APP_NAME: "Milkbun",
    APP_FAVICON: "/Assets/milkbun/favicon.ico",
  };